import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CountryService from "../../../../services/catalogs/CountryService";

export const REQUEST_FETCH_COUNTRY = "REQUEST_FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_ERROR = "FETCH_COUNTRY_ERROR";
export const INITIAL_STATE_COUNTRY = "INITIAL_STATE_COUNTRY";

function requestFetchCountry() {
  return {
    type: REQUEST_FETCH_COUNTRY,
  };
}

function fetchCountrySuccess(json) {
  return {
    type: FETCH_COUNTRY_SUCCESS,
    country: json.data,
  };
}

function fetchCountryError(json) {
  return {
    type: FETCH_COUNTRY_ERROR,
    error: json.data,
  };
}

export function initialStateCountry() {
  return {
    type: INITIAL_STATE_COUNTRY,
  };
}

export function fetchCountry(country_id) {
  return (dispatch) => {
    dispatch(requestFetchCountry());
    return CountryService.getCountry(country_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchCountrySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchCountry(country_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchCountryError(json.data));
      }
    });
  };
}
